import { SWResourceLoadableInfo } from "./SWResourceLoadable";
export * from "./SWBaseLoadable";
export * from "./SWResourceLoadable";
export * from "./SWLocalizationProviderLoadable";
export const LoadableMap = {
    resource: SWResourceLoadableInfo
};
